import $ from "jquery";
import React, { useState, useEffect, forwardRef } from 'react';
import ReactGA from 'react-ga4';

function Modal(props, refs) {

    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState();
    const container = document.body;

    useEffect(() => {
        $('#' + props.id).appendTo(container);
        if (props.showTooltips) {
            $('[data-toggle="tooltip"]').tooltip();
        }
    }, []);

    const openModal = (e) => {
        //console.log('Opening Modal ...');
        if (e) {
            e.preventDefault();
        }
        // This is mainly to load the content and fetch content only when clicked.
        const content = React.Children.map(props.children, child => (
            //passing parent ref functions
            React.cloneElement(child, { resizeModal: resizeModal, closeModal: closeModal, date: new Date().getMilliseconds(), title: props.title })
        ));
        setIsOpen(true);
        setContent(content);
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked to Open ' + props.title,
            label: 'Open ' + props.title
        });
    }

    const closeModal = (e) => {
        $('.bbox').show();
        if (e) {
            e.preventDefault();
        }
        setIsOpen(false);
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked on Close ' + props.title,
            label: 'Closed ' + props.title
        });

        if (props.afterClose) {
            props.afterClose();
        }
    }

    const resizeModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        $(e.target).toggleClass("fa-expand fa-compress");
        $(e.target).closest(".modal-dialog").toggleClass("modal-lg modal-fullscreen");
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked on Resize ' + props.title,
            label: 'Resize ' + props.title
        });
    }
    React.useImperativeHandle(refs, () => ({
        closeModal
    }));

    const toggleDialog = isOpen ? 'modal fade show' : 'modal';
    const toggleOverlay = isOpen ? 'modal-backdrop fade show' : 'modal';
    return (
        <React.Fragment>
            <span data-toggle="tooltip" title={props['tooltip-title']} style={props.style} onClick={openModal}>{props.label ? props.label : props.title}</span>
            <div id={props.id} className="modal-open">
                <div className={toggleDialog} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className={props.size ? "modal-dialog " + props.size : "modal-dialog"} style={{ maxHeight: "calc(100vh - 6rem)" }} role="document">
                        <div className="modal-content bg-shadow" style={{ marginTop: "4rem" }}>
                            {isOpen && content}
                        </div>
                    </div>
                </div>
                <div className={toggleOverlay}></div>
            </div>
        </React.Fragment>
    );
}

export default forwardRef(Modal);